import React from 'react';
import { OverlayTrigger } from 'react-bootstrap';

import { gettext } from '../../../i18n/service.js';
import getTooltip from '../../../businessLogic/getTooltip.js';

export function CashOnDelivery({ order }) {
  const tooltip = getTooltip(gettext("COD-AMOUNT"));
  return order.cashOnDelivery
          ? (
              <OverlayTrigger
                placement="top"
                overlay={tooltip}>
                  <div style={{display: 'inline-block'}}>
                    {order.cashOnDeliveryAmount}
                  </div>
              </OverlayTrigger>
            )
          : null;
}



// WEBPACK FOOTER //
// ./src/components/sidebarOrders/order/CashOnDelivery.js